import AuthOptions from "../AuthOptions";
import LoginForm from "./LoginForm";
import "./LoginView.css";
import { Divider } from "@chakra-ui/layout";
import LogoComponent from "components/UIComponents/LogoComponent";
import { Box, Heading } from "@chakra-ui/react";
import { Link } from "react-router-dom";

const LoginView = () => {
  return (
    <main className="login-view">
      <Box mb={7}>
        <Link to="/">
          <LogoComponent />
        </Link>
      </Box>
      <Heading mb={7} size="lg">
        Log in to your account
      </Heading>
      <AuthOptions />
      <Divider mt={7} mb={7} height={"1px"} width="42%" />
      <LoginForm />
    </main>
  );
};

export default LoginView;